module.exports = __webpack_public_path__ + "static/media/essay-question-icon.64f00ba4.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/essay-question-icon.svg
// module id = 1029
// module chunks = 0